export const MAX_AVATAR_SIZE = 15;
